import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { IUserLog, UserListItem } from "interface/user";
import { format } from "date-fns";

interface UserLogProps {
	items: IUserLog[];
	loading: boolean;
}

const UserLogMobile: FC<UserLogProps> = ({ items, loading }) => {
	const { t } = useTranslation();
	const empty = useMemo(
		() => !loading && items.length === 0,
		[items.length, loading],
	);

	return (
		<div className="landing-note-list-mobile">
			{empty && (
				<div className="landing-note-list-mobile-empty">{t("NoRows")}</div>
			)}

			{items.map((item, itemIndex) => {
				return (
					<div key={itemIndex} className="landing-note-list-card">
						<div className="landing-note-list-card-body">
							<div>
								<strong>{t("Date")}</strong>
								<span>
									{format(new Date(item.datestamp), "dd.MM.yyyy HH:mm:ss")}
								</span>
							</div>
							<div>
								<strong>{t("Name")}</strong>
								<span>{item.userName}</span>
							</div>

							<div>
								<strong>{t("Operation")}</strong>
								<span>{item.operation}</span>
							</div>
							<div>
								<strong>{t("Message")}</strong>
								<span>{item.logMessage}</span>
							</div>
						</div>
					</div>
				);
			})}

			{loading && (
				<div className="landing-note-list-mobile-loading">{t("Loading")}</div>
			)}
		</div>
	);
};

export default UserLogMobile;
